import React from 'react';
import classnames from 'classnames';
import { toast } from '@platform/api';
import { 
    Sidebox as SideBox,
    Input, 
    Tooltip, 
    ButtonGroup, 
    Button, 
} from '@platform/base';
import { getViewportBoundary } from '../../utils';
import { setLocalStorageColumnsWidth } from '../../adapter/utils/handleProps';
import { getRawColumns, setColumns, resetColumns } from './requestUtil';
import './index.less';
import Dnd from './dnd';
class ColSetting extends React.Component {
        state = { 
            show: false,
            leftKeyword: '', 
            rightKeyword: '',
            rawColumns: [], // 左边的
            viewColumnKeys: [], // 右边的
            rawMap: {}, // 左边的key => col映射
            viewMap: {}, // 右边的key => col映射
            subModalShow: false, // 列宽设置弹窗
            changedColumn: {}, // 正在进行列宽设置的列 { key, width }
        };

        UNSAFE_componentWillReceiveProps(nextProps){
            // 改变显示为true时，请求数据
            if(!this.props.show && nextProps.show){ 
                // 优化显示效果，否则取消后第二次进来用的是上一次的数据
                this.setState({ 
                    viewColumnKeys: [], // 右边
                    rawColumns: [], // 左边
                    viewMap: {}, 
                    rawMap: {},
                }, () => {
                    const { store, id } = this.props;
    
                    getRawColumns(store, id).then(res => {
                        if(res.success){
                            let columnsWidth = store.getColumnsWidth(),
                                viewMap = {},
                                rawMap = {},
                                viewColumnKeys = res.data[1][id].items.map((col, index) => {
                                    col = { 
                                        ...col, 
                                        key: col.attrcode,
                                        ...store.getColumnProps(col.attrcode),
                                        width: String(columnsWidth?.[col.attrcode] ?? store.getColumnProps(col.attrcode, 'width')),
                                        _index: index,
                                        required: col.require ?? col.required, // 后台数据错误
                                    };
                                    viewMap[col.key] = col;
                                    return col.key;
                                }),
                                rawColumns = res.data[0].areas[id].items
                                    .map(col => { 
                                        let visibleCol = store.getColumnProps(col.code),
                                            { visible, islock, width, ...others } = visibleCol;
                                        Object.assign(col, { ...others });
                                        col.key = col.code;
                                        rawMap[col.key] = col;
                                        return col;
                                    });
    
                            this.setState({ 
                                viewColumnKeys, // 右边
                                rawColumns, // 左边
                                viewMap, 
                                rawMap,
                                show: true,
                            });
                        }
                    }).catch(err => {
                        let errMsg = JSON.parse(err.message);
                        toast({
                            color: 'warning',
                            content: errMsg,
                            mark: 'lock-tip',
                        });
                    });
                });

            } else if(this.props.show && !nextProps.show) {
                this.setState({ show: false });
            }
        }

        render(){
            let { leftKeyword, rightKeyword, show } = this.state;
            let { locale } = this.props;

            return (<>
                <SideBox 
                    title={this.renderTitle()}
                    show={show}
                    mask={true}
                    maskClose={this.handleClose}
                    keyboard={true}
                    width={1000}
                    onClose={this.handleClose}
                    className="set-table-column-drawer"
                >
                    <div className='table-column-content'>
                        <div className='table-column-content-left-box'>
                            <h3 className="table-column-content-title">
                                <span>
                                    {locale['menu_to_add'] /*待添加*/}
                                </span>
                                <span className="table-column-content-title-search">
                                    <Input
                                        value={leftKeyword}
                                        type="search"
                                        placeholder={locale['menu_input_holder'] /*请输入字段名称*/}
                                        onChange={value => this.setState({ leftKeyword: value })}
                                        clearSearch={() => this.setState({ leftKeyword: '' })}
                                    />
                                </span>
                            </h3>
                            <ul className="table-column-content-left">
                                {this.renderLeftList()}
                            </ul>
                        </div>
                        <div className="table-column-content-right-box">
                            <h3 className="table-column-content-title">
                                <span>
                                    {locale['menu_to_added'] /*已添加*/}
                                </span>
                                <span className="table-column-content-title-search">
                                    <Input
                                        value={rightKeyword}
                                        placeholder={locale['menu_input_holder'] /*请输入字段名称*/}
                                        type="search"
                                        onChange={value => this.setState({ rightKeyword: value })}
                                        clearSearch={() => this.setState({ rightKeyword: '' })}
                                    />
                                </span>
                            </h3>
                            <div className="table-column-content-right">
                                {this.renderRightList()}
                            </div>
                        </div>
                    </div>
                </SideBox>
            </>
            );
        }

        renderTitle = () => {
            let { locale } = this.props;
            return (
                <div className="set-table-column-drawer-header">
                    <h3 className="title">
                        {locale['menu_column_setting'] /*列表设置*/}
                        <Tooltip
                            placement="rightTop"
                            className='col-setting-tips'
                            overlay={<div>
                                <p>{locale['table_tips'] /*提示*/}：</p>
                                <p>{locale['menu_tip1'] /*1. 点击字段名称右侧的*/}
                                    <i className='icon iconfont icon-ncc-sq' />
                                    {locale['or'] /*或*/}
                                    <i className='iconfont icon-shanchu4' />
                                    {locale['menu_tip2'] /*，控制该字段的显示或隐藏；*/}
                                </p>
                                <p>{locale['menu_tip3'] /*2. 在“已添加”处拖动字段名称，控制顺序，且靠近上方的会优先显示；*/}
                                </p>
                                <p>{locale['menu_tip5'] /*3. 点击*/}
                                    <i className='iconfont icon-weisuoding' />
                                    {locale['menu_tip6'] /*冻结列的位置，如果冻结过多字段，会导致表格不能滚动。*/}
                                </p>
                            </div>}
                        >
                            <i className='iconfont icon-bangzhutishi' />
                        </Tooltip >
                    </h3>
                    <div className="header-btn">
                        <ButtonGroup>
                            <Button
                                colors='primary'
                                onClick={this.handleSave}
                                className="button-primary"
                            >{locale['table_ok'] /*确定*/}</Button>
                            <Button
                                onClick={this.handleReset}
                            >{locale['table0031'] /*重置*/}</Button>
                        </ButtonGroup>
                        <Button className="cancel-btn" onClick={this.handleClose}>
                            {locale['table_cancel'] /*取消*/}
                        </Button>
                    </div>
                </div>
            );
        }

        renderLeftList = () => {
            let { hiddenLeftItem } = this.props,
                { leftKeyword, viewColumnKeys, viewMap, rawColumns } = this.state,
                visibleColumns = this.getViewColumns();
            let { locale, store } = this.props;
            let status = store.getStatus();

            // 模板上可显示，实际不显示的列
            // TODO 看下问题NCC-43188 可能需要在这里加上columns里的changeMetaCol=true的列
            rawColumns = rawColumns.filter(col => 
                col.visible && !viewMap[col.key]?.visible && !hiddenLeftItem?.includes(col.key),
            );

            return (
                rawColumns.map(col => 
                    <li 
                        className={classnames(
                            'show-column', 
                            { 'select-by-keyword': leftKeyword && col.label?.includes(leftKeyword) },
                        )}
                        key={col.key}
                    >
                        {col.required && status !== 'browse' && <i className='unselected-mark-icon iconfont icon-xinghao'></i>}
                        <span className="label">{col.label}</span>
                        <Tooltip 
                            placement="top"
                            overlay={locale['add'] /*添加*/}
                            delayHide={1}
                            delayShow={1000}
                        >
                            <i 
                                className="icon iconfont icon-ncc-sq"
                                onClick={() => {
                                    // 改变visible 且添加到队尾 要保证customer列在最后
                                    viewMap[col.key].visible = true;
                                    this.setState({ viewMap });

                                    this.moveColumns(viewMap[col.key]._index, viewColumnKeys.length - 1);
                                }}
                            />
                        </Tooltip>
                        <Tooltip
                            placement="top"
                            overlay={locale['lock'] /*锁定*/}
                            delayHide={1}
                            delayShow={1000}
                        >
                            <i 
                                className="icon iconfont icon-weisuoding"
                                onClick={() => {
                                    // 添加到最后一个锁定的列的后面（如果没有已锁定的，则作为第一个）
                                    // viewIndex
                                    let lastLockedIndex = -1;
                                    for(let i = visibleColumns.length - 1; i >=0; i--) {
                                        if (visibleColumns[i].islock) {
                                            lastLockedIndex = i;
                                            break;
                                        }
                                    }

                                    viewMap[col.key].visible = true;
                                    this.setState({ viewMap });
                                    
                                    // 有锁定列，插到锁定列后面，否则插到第一位
                                    this.moveColumns(viewMap[col.key]._index, lastLockedIndex > -1 ? visibleColumns[lastLockedIndex]._index + 1 : 0);

                                    requestAnimationFrame(() => {
                                        // getMaxLockColumnIndex 依赖 moveColumns 中 setState 后的数据
                                        if(lastLockedIndex + 1 > this.getMaxLockColumnIndex()){
                                            toast({
                                                // duration: Infinity,
                                                color: 'warning',
                                                content: locale['table_colseting_tip14'] /*字段过多，无法冻结*/,
                                                mark: 'lock-tip',
                                            });
                                            return;
                                        }
    
                                        viewMap[col.key].islock = true;
                                        viewMap[col.key].resizable = false;
                                        this.setState({ viewMap });
                                    });
                                }}
                            />
                        </Tooltip> 
                        {/* <Tooltip
                            placement="top"
                            overlay="高亮"
                            delayHide={1}
                            delayShow={1000}
                        >
                            <i 
                                className='icon iconfont icon-gaoliang'
                                onClick={() => { 
                                    viewMap[col.key].visible = true;
                                    viewMap[col.key].ishighlight = true;
                                    
                                    this.setState({ viewMap });
                                }}
                            />
                        </Tooltip> */}
                    </li>,
                )
            );
        }

        renderRightList = () => {
            let { rightKeyword, viewMap } = this.state,
                visibleColumns = this.getViewColumns();
            let { locale, store } = this.props;
            let status = store.getStatus();

            if(!visibleColumns.length) return null;

            let list = visibleColumns.map((col, index) => 
                <div key={col.key} draggable={!col.islock} className={classnames(
                    "show-column",
                    { 'select-by-keyword': rightKeyword && col.label?.includes(rightKeyword) },
                )}>
                    {col.required && status !== 'browse' && <i className='unselected-mark-icon iconfont icon-xinghao'></i>}
                    <span className="label">{col.label}</span>
                    {!col.islock && (!col.required || status === 'browse') && <Tooltip
                        placement="top"
                        overlay={locale['hide'] /*隐藏*/}
                        delayHide={1}
                        delayShow={1000}
                    >
                        <i 
                            className={classnames("icon iconfont icon-shenpibohui")}
                            onClick={() => {
                                viewMap[col.key].visible = false;
                                viewMap[col.key].islock = false;
                                this.setState({ viewMap });
                            }}
                        />
                    </Tooltip>}
                    {/* <Tooltip
                        placement="top"
                        overlay='列宽'
                        delayHide={1}
                        delayShow={1000}
                    >
                        <i 
                            className="icon iconfont icon-liekuanshezhi"
                            onClick={() => {
                                this.setState({
                                    subModalShow: true,
                                    changedColumn: {
                                        key: col.key,
                                        width: viewMap[col.key].width,
                                    }, 
                                });
                            }}
                        />
                    </Tooltip> */}
                    {/* <Tooltip
                        placement="top"
                        overlay="高亮"
                        delayHide={1}
                        delayShow={1000}
                    >
                        <i 
                            className={classnames(
                                'icon', 'iconfont', 
                                { 'icon-gaoliang': !col.ishighlight },
                                { 'icon-tgaoliang': col.ishighlight },
                            )} 
                            onClick={() => { 
                                viewMap[col.key].ishighlight = !viewMap[col.key].ishighlight;
                                this.setState({ viewMap });
                            }}
                        />
                    </Tooltip> */}
                    {!col.islock && <Tooltip
                        placement="top"
                        overlay={locale['lock'] /*锁定*/}
                        delayHide={1}
                        delayShow={1000}
                    >
                        <i
                            className="icon iconfont icon-weisuoding"
                            onClick={() => { 
                                if(index > this.getMaxLockColumnIndex()){
                                    // 判断锁定个数是否超过了限制
                                    toast({
                                        // duration: Infinity,
                                        color: 'warning',
                                        content: locale['table_colseting_tip14'] /*字段过多，无法冻结*/,
                                        mark: 'lock-tip',
                                    });
                                    return;
                                }
                                
                                // 锁定要把前面的都锁定
                                for(let i = 0; i <= index; i++) {
                                    visibleColumns[i].islock = true;
                                    visibleColumns[i].resizable = false;
                                }
                                this.forceUpdate();
                            }}
                        />
                    </Tooltip>}
                    {/* 锁定的数据只有最后一个有解锁图标 */}
                    {col.islock && !visibleColumns[index + 1]?.islock && 
                        <Tooltip
                            placement="top"
                            overlay={locale['unlock'] /*解锁*/}
                            delayHide={1}
                            delayShow={1000}
                        >
                            <i
                                className="icon iconfont icon-suoding"
                                onClick={() => {
                                    // 要把前面所有的都解锁
                                    for(let i = 0; i <= index; i++) {
                                        viewMap[visibleColumns[i].key].islock = false;
                                        viewMap[visibleColumns[i].key].resizable = true;
                                    }

                                    this.setState({ viewMap });
                                }}
                            />
                        </Tooltip>}
                </div>,
            );

            return <Dnd
                list={list}
                onStop={this.handleDragComplete}
            />;
        }

        // 同步state.viewColumns到props.columns
        updatePropColumns = () => {
            let { store, id } = this.props,
                { viewMap } = this.state,
                meta = store.getMeta(),
                lockColumns = [], 
                normalColumns = [];

            meta[id].items
                .sort((colA, colB) => viewMap[colA.attrcode] && viewMap[colB.attrcode] ? viewMap[colA.attrcode]._index - viewMap[colB.attrcode]._index : 0)
                .forEach(col => {
                    col = { ...col, ...viewMap[col.attrcode] };
                    if(col.islock){
                        lockColumns.push(col);
                    } else {
                        normalColumns.push(col);
                    }
                });
            meta[id].items = lockColumns.concat(normalColumns);
            store.setMeta(meta, id);
        }

        handleClose = () => {
            this.props.onClose?.();
        }

        handleDragComplete = (sourceIndex, destinationIndex) => {
            if(sourceIndex === destinationIndex) return;
            
            const visibleColumns = this.getViewColumns();

            const startCol = visibleColumns[sourceIndex];
            const endCol = visibleColumns[destinationIndex];

            this.moveColumns(startCol._index, endCol._index);
        }

        handleReset = () => {
            const { store, onClose, id, locale } = this.props;

            resetColumns(store, id).then(res => {
                if(res.success){
                    let { rawColumns } = this.state;

                    // 清除localStorage里的列宽信息
                    setLocalStorageColumnsWidth(store, id, null);

                    this.setState({
                        viewColumnKeys: rawColumns.map((col, index) => {
                            col._index = index;
                            return col.key;
                        }), 
                        viewMap: rawColumns.reduce((viewMap, col, index) => {
                            col._index = index;
                            // 列宽不重置
                            col.width = store.getColumnProps(col.key, 'width');
                            viewMap[col.key] = { islock: false, resizable: true, ...col };
                            return viewMap;
                        }, {}),
                    }, this.updatePropColumns);
                    toast({ content: locale['column_reset_success'] /*列设置重置成功*/, light: true });
                    onClose?.();
                }
            });
            
        }

        handleSave = () => {
            const { store, id, onClose, locale } = this.props;
            let { viewColumnKeys, viewMap } = this.state,
                lockColumns = [],
                normalColumns = [];

            viewColumnKeys.forEach(key => {
                let col = viewMap[key];
                if(col.islock) {
                    lockColumns.push(col);
                } else {
                    normalColumns.push(col);
                }
            });

            setColumns(store, id, lockColumns.concat(normalColumns)).then(res => {
                if(res.success){
                    this.updatePropColumns();
                    toast({ content: locale['column_set_success'] /*列设置保存成功*/, light: true });
                    onClose?.();
                }
            });
        }

        // 计算剩余宽度，确定可以锁定（固定列）的个数
        getMaxLockColumnIndex = () => {
            let { tableBody, store } = this.props,
                viewColumns = this.getViewColumns(),
                maxIndex = viewColumns.length - 1;
                
            let { left, right } = getViewportBoundary(tableBody),
                scrollWidth = right - left;

            // scrollWidth不包含已经锁定的列，先把已经锁定的列的宽度加上，得到真正的视口宽度
            for(let i = 0, l = viewColumns.length; i < l; i++) {
                if(store.getColumnProps(viewColumns[i].key, 'islock')) {
                    scrollWidth += Number(viewColumns[i].width);
                }
            }

            // 再算maxIndex
            for(let i = 0, l = viewColumns.length, totalWidth = 0; i < l; i++) {
                totalWidth += Number(viewColumns[i].width);
                if (totalWidth > scrollWidth) {
                    maxIndex = i - 1;
                    break;
                }
            }

            return Math.max(0, maxIndex);
        }

        // dataIndex
        moveColumns = (startIndex, endIndex) => {
            const { viewColumnKeys, viewMap } = this.state;

            let temp = viewColumnKeys[startIndex];

            if (startIndex < endIndex) {
                // 从前往后移，前面的数量减了1，所以endIndex要减1
                endIndex--;
                for (
                    let i = startIndex + 1;
                    i <= endIndex;
                    i++
                ) {
                    viewColumnKeys[i - 1] = viewColumnKeys[i];
                    viewMap[viewColumnKeys[i - 1]]._index = i - 1;
                }
            } else {
                for (
                    let i = startIndex - 1;
                    i >= endIndex;
                    i--
                ) {
                    viewColumnKeys[i + 1] = viewColumnKeys[i];
                    viewMap[viewColumnKeys[i + 1]]._index = i + 1;
                }
            }

            viewColumnKeys[endIndex] = temp;
            viewMap[viewColumnKeys[endIndex]]._index = endIndex;

            this.setState({ viewColumnKeys, viewMap });
        }

        getViewColumns = () => {
            let { hiddenLeftItem } = this.props,
                { viewColumnKeys, viewMap } = this.state;

            return viewColumnKeys.map(key => viewMap[key]).filter(col => 
                col.visible && !hiddenLeftItem?.includes(col.key), 
            );
        }
}
    
export default ColSetting;

// 打开
/**
 * 1、打开列设置 => getUserTemplateMap.do => res
 *  - rawData = res[0]: 原始的模板数据（没设置过的）（重置应该是重置到这个状态）
 *  - viewData = res[1]: 界面的模板数据（设置过的）（和业务查询的模板一样）
 * 2、this.setState({ viewData })
 *  - 存state，后续要操作这个数据
 * 3、render: 
 *  - 这里要注意，rawData和viewData都不与metaData(storeData)同步，可能需要手动同步一下
 *  - viewData.filter(e => e.visible) => 右边（已添加）
 *  - colMap: viewData => { [key]: { ...col, _index } }
 *  - rawData.filter(e => e.visible && !colMap[e.attrcode].visible) => 左边（待添加）
 * 4、add/remove => e.visible
 *  - add => 和拖拽排序一样
 * 5、lock => e.islock
 * 6、ishighlight => e.ishighlight
 * 7、拖拽排序 => viewData（保留原始的相对位置）（参考以前的）
 */

// 保存: propertySetting.do => viewData, setMeta

// 重置: removeUserPropertySettings.do, setMeta

// 取消: 关闭模态框

// 其他设置页签的render
//  * render(){
//             let { leftKeyword, rightKeyword, subModalShow, changedColumn, tabKey } = this.state,
//                 { show, wrapStatus, onWrapChange } = this.props;

//             return (<>
//                 <SideBox 
//                     title={this.renderTitle()}
//                     show={show}
//                     mask={true}
//                     width={1000}
//                     onClose={this.handleClose}
//                     className="set-table-column-drawer"
//                 >
//                     <Tabs 
//                         defaultActiveKey="colSetting" 
//                         tabBarStyle="simple"
//                         onTabClick={key => this.setState({ tabKey: key })}
//                     >
//                         <TabPane key={KEY_COL_SETTING} tab={/*locale */'列表表格'}></TabPane>
//                         <TabPane key={KEY_OTHER_SETTING} tab={/*locale */'其他设置'}></TabPane>
//                     </Tabs>
//                     {tabKey === KEY_COL_SETTING && <div className='table-column-content'>
//                         <div className='table-column-content-left-box'>
//                             <h3 className="table-column-content-title">
//                                 <span>
//                                     {/* locale['menu_to_add'] */'待添加'}
//                                 </span>
//                                 <span className="table-column-content-title-search">
//                                     <Input
//                                         value={leftKeyword}
//                                         type="search"
//                                         placeholder={/*locale['menu_input_holder']*/'请输入字段名称'}
//                                         onChange={value => this.setState({ leftKeyword: value })}
//                                         clearSearch={() => this.setState({ leftKeyword: '' })}
//                                     />
//                                 </span>
//                             </h3>
//                             <ul className="table-column-content-left">
//                                 {this.renderLeftList()}
//                             </ul>
//                         </div>
//                         <div className="table-column-content-right-box">
//                             <h3 className="table-column-content-title">
//                                 <span>
//                                     {/* locale['menu_to_added'] */'已添加'}
//                                 </span>
//                                 <span className="table-column-content-title-search">
//                                     <Input
//                                         value={rightKeyword}
//                                         placeholder={/*locale['menu_input_holder']*/'请输入字段名称'}
//                                         type="search"
//                                         onChange={value => this.setState({ rightKeyword: value })}
//                                         clearSearch={() => this.setState({ rightKeyword: '' })}
//                                     />
//                                 </span>
//                             </h3>
//                             <div className="table-column-content-right">
//                                 {this.renderRightList()}
//                             </div>
//                         </div>
//                     </div>}
//                     {tabKey === KEY_OTHER_SETTING && <div className="other-setting-content">
//                         <div className="title">{/* locale['set_width_height'] */'宽高设置'}：</div>
//                         <div className="item">
//                             <span>{/**locale['auto_wrap'] */'自动换行'}</span>
//                             <Checkbox checked={wrapStatus} onChange={onWrapChange}/>
//                         </div>
//                     </div>}
//                 </SideBox>
//                 <Modal 
//                     className="set-width-modal"
//                     show={subModalShow}
//                     autoFocus={false}
//                     modalAutoFocus={false}
//                 >
//                     <Header closeButton>
//                         <Title>{/*locale[''] */'调整列宽'}</Title>
//                     </Header>
//                     <Body>
//                         <span>{'调整字段宽度至(px):'}</span>
//                         <Input 
//                             value={changedColumn.width} 
//                             autoFocus
//                             onChange={value => {
//                                 value = Number(value);
//                                 if(isNumber(value) && value > 0){
//                                     changedColumn.width = value;
//                                     this.setState({ changedColumn });
//                                 }
//                             }}
//                         />
//                     </Body>
//                     <Footer>
//                         <Button
//                             colors="primary"
//                             onClick={() => {
//                                 const { viewMap, changedColumn } = this.state;

//                                 viewMap[changedColumn.key].width = String(changedColumn.width);

//                                 this.setState({ subModalShow: false, viewMap });
//                             }}
//                         >
//                             {/*locale['confirm'] */'确定'}
//                         </Button>
//                         <Button 
//                             onClick={() => this.setState({ subModalShow: false })}
//                         >
//                             {/*locale['cancel']*/'取消'}
//                         </Button>
//                     </Footer>
//                 </Modal>
//             </>
//             );
//         }

//  <ButtonGroup>
//         <Button onClick={this.saveColumnWidth}>
//             {'保存列宽'}
//         </Button>
//         <Button onClick={onResetWidth}>
//             {'重置列宽'}
//         </Button>
// </ButtonGroup>